import React from 'react';
import { string, object } from 'prop-types';
import styles from './styles/styles.module.scss';

const OnePercentModule = ({ title, icon, text, className }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

OnePercentModule.propTypes = {
  title: string,
  icon: object,
  text: string,
  className: string
};

OnePercentModule.defaultProps = {
  title: '',
  icon: <></>,
  text: '',
  className: ''
};

export default OnePercentModule;
